import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/settings-04.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M6 12C7.86384 12 9.42998 13.2748 9.87402 15H21C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H9.87402C9.42998 18.7252 7.86384 20 6 20C3.79086 20 2 18.2091 2 16C2 13.7909 3.79086 12 6 12ZM20 8C20 6.89543 19.1046 6 18 6C16.8954 6 16 6.89543 16 8C16 9.10457 16.8954 10 18 10C19.1046 10 20 9.10457 20 8ZM4 16C4 17.1046 4.89543 18 6 18C7.10457 18 8 17.1046 8 16C8 14.8954 7.10457 14 6 14C4.89543 14 4 14.8954 4 16ZM22 8C22 10.2091 20.2091 12 18 12C16.1362 12 14.57 10.7252 14.126 9H3C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7H14.126C14.57 5.27477 16.1362 4 18 4C20.2091 4 22 5.79086 22 8Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Settings04Icon };
